module.exports = __webpack_public_path__ + "static/media/26UNRWA21.90c3313d.jpg";